<template>
  <div class="register">
    <app-loading :active="loading"></app-loading>
    <app-unlogged-layout>
      <form @submit.prevent="register">
        <app-input name="name" type="text" placeholder="Imię i Nazwisko" v-model="form.name" v-validate="'required'" required></app-input>
        <app-input name="email" type="email" placeholder="Email" v-model="form.email" v-validate="'required|email'" required></app-input>
        <!-- <app-input name="phone" type="phone" placeholder="Telefon" v-model="form.phone"></app-input> -->
        <app-input name="password" type="password" placeholder="Hasło" v-model="form.password" v-validate="'required|min:8'" required></app-input>
        <app-input name="repeat_password" type="password" placeholder="Powtórz hasło" v-model="form['password_confirmation']" v-validate="'required|min:8'" required></app-input>

        <small class="form-error">{{ error }}</small>
        <br>

        <button class="btn btn--gradient">Zarejestruj się</button>

        <br>
        <small class="center">Masz już konto?
          <router-link to="/login">Zaloguj się!</router-link>
        </small>
      </form>
      <small class="recaptcha-alert">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</small>
    </app-unlogged-layout>
  </div>
</template>

<script>
  import UnloggedLayout from '@/layout/UnloggedLayout.vue'
  import Input from "@/components/Input.vue";
  import Loading from "@/components/Loading.vue";
  import {api} from '@/api.js'

  export default {
    name: 'app-login',
    data: () => {
      return {
        form: {
          name: '',
          email: '',
          // phone: '',
          password: '',
          "password_confirmation": ''
        },
        loading: false,
        error: ''
      }
    },
    methods: {
      async register() {
        console.log(this.form);
        this.loading = true
        this.error = ''
        try {

          let recaptcha_token = await this.$recaptcha('register')
          const resp = await api.post('/user', {...this.form, recaptcha: recaptcha_token, client_id: 1})

          recaptcha_token = await this.$recaptcha('login')
          this.$store.dispatch('user/login', {form: this.form, recaptcha_token, nextURL: this.$route.params.nextURL || '/'})

        } catch(e) {
          if (e.response && e.response.data) {
            this.error = e.response.data.message || e.response.data.error
          } else {
            console.error(e)
            this.error = 'Wystąpił błąd podczas rejestracji.'
          }
        }
        this.loading = false
      }
    },
    metaInfo: {
      title: 'Rejestracja'
    },
    components: {
      appUnloggedLayout: UnloggedLayout,
      appLoading: Loading,
      appInput: Input
    }
  }
</script>

<style lang="scss" scoped>

</style>
